// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__283h6","placeholdersHeader":"styles_placeholdersHeader__29taF","editorStyle":"styles_editorStyle__1i4ja","placeholdersBox":"styles_placeholdersBox__1kpQ_"};